module.exports = __webpack_public_path__ + "img/logo.40e758cc.png";